import { ProgressBar } from "../../../../components/progressbar/ProgressBar";
import { InputText } from "../../../../components/forms/InputText";
import { formatSecondsToHMS } from "../../../../helpers/date/date-helper";
import { Loader } from "../../../../components/loading/Loader";
import { useState } from "react";


const BathMaintenanceLine = ({ bath, updateBath, refetchBaths, bathsData }) => {
  const usedDuration = bathsData?.find((b) => bath.data.real_ids.map((id) => parseInt(id)).includes(parseInt(b.pool_id)))?.total_duration_seconds ?? 0;
  const usedDips = bathsData?.find((b) => bath.data.real_ids.map((id) => parseInt(id)).includes(parseInt(b.pool_id)))?.dips ?? 0;

  const [threshold, setThreshold] = useState(bath.data.threshold ?? 0);
  const [dips, setDips] = useState(bath.data.dips ?? 0);

  const percentageDuration = Math.min(100, Math.ceil(usedDuration / (parseFloat(threshold) * 3600 + 1e-9) * 100));
  const percentageDips = Math.min(100, Math.ceil(usedDips / (parseInt(dips) + 1e-9) * 100));

  const handleDataBlur = async () => {
    const nextThreshold = Number(threshold);
    const nextDips = Number(dips);

    if (!Number.isFinite(nextThreshold)) {
      setThreshold(String(bath.data.threshold ?? 0));
      return;
    }

    if (!Number.isFinite(nextDips)) {
      setDips(String(bath.data.dips ?? 0));
      return;
    }

    if (nextThreshold === bath.data.threshold && nextDips === bath.data.dips) return;

    await updateBath({
      ...bath,
      data: {
        ...bath.data,
        threshold: nextThreshold,
        dips: nextDips,
      },
    });

    refetchBaths?.();
  };

  return (
    <div className="flex gap-4 items-center bg-perception-black-700 px-4 py-2 rounded-md">
      <div className="w-1/4">
        {bath.name}
      </div>
      <div className="w-2/4 flex flex-col gap-1 text-perception-gray-600 text-xs">
        <div className="flex justify-between">
          <div>Usage: {formatSecondsToHMS(usedDuration, 'long', false)}</div>
          <div>{Math.floor(percentageDuration)}%</div>
        </div>
        <ProgressBar value={percentageDuration} height="h-2.5" color={percentageDuration >= 80 ? '#4164FD' : '#929292'} bgColor="bg-perception-gray-700"/>
        <ProgressBar value={percentageDips} height="h-2.5" color={percentageDips >= 80 ? '#4164FD' : '#929292'} bgColor="bg-perception-gray-700"/>
        <div className="flex justify-between">
          <div>Dips: {`${usedDips}/${dips}`}</div>
          <div>{Math.floor(percentageDips)}%</div>
        </div>
      </div>
      <div className="w-1/4 flex gap-3 justify-end">
        <div className="flex gap-2 items-center text-sm">
          Dips
          <InputText
            value={dips}
            setValue={setDips}
            onBlur={handleDataBlur}
            theme="dark"
            className="bg-perception-black-500 w-12"
            size="sm"
          />
        </div>
        <span className="text-perception-gray-700">/</span>
        <div className="flex gap-2 items-center text-sm">
          Threshold
          <InputText
            value={threshold}
            setValue={setThreshold}
            onBlur={handleDataBlur}
            theme="dark"
            className="bg-perception-black-500 w-12"
            size="sm"
          />
          h
        </div>
      </div>
    </div>
  );
};

export const DiorDataDashboardBathsMaintenance = ({ baths, bathsAreLoading, refetchBaths, updateBath, bathsData }) => {  return (
    <div className="flex flex-col gap-2 mt-4">
      {bathsAreLoading ? <Loader category="transparent"/> :
        <>
          {baths
            .filter((bath) => !bath.name.includes('AGUAS') && !bath.data.skip)
            .map((bath, index) => (
              <BathMaintenanceLine
                bath={bath}
                updateBath={updateBath}
                refetchBaths={refetchBaths}
                bathsData={bathsData}
                key={index}
              />
          ))}
        </>
      }
    </div>
  );
};